up.Offline = class Offline extends up.Error {
};
